import { useGetEmployeesByIdsQuery } from '@/services/gql/graphql.generated';
import { useEmployeeList } from '@/services/staff/useEmployeeList';
import { displayName } from '@/services/translation/name';
import { EmployeeForShiftItem } from '@/types/employeeForShift.types';
import { WorkingShift } from '@/types/daily.types';
import { useMemo } from 'react';

export const useTemplateEmployees = (selectedEmployeeId?: string) => {
  const { allEmployees } = useEmployeeList();
  const missingEmployeeIds =
    selectedEmployeeId && !allEmployees.find(employee => employee.identityId === selectedEmployeeId)
      ? [selectedEmployeeId]
      : undefined;

  const [{ data: missingEmployeesData }] = useGetEmployeesByIdsQuery({
    variables: { ids: missingEmployeeIds || [] },
    pause: !missingEmployeeIds || missingEmployeeIds.length === 0
  });

  return useMemo(() => {
    const employees = [...allEmployees, ...((missingEmployeesData?.employeesByIds || []).filter(Boolean) as typeof allEmployees)];
    const deduped = employees.filter((employee, index) => {
      return employees.findIndex(candidate => candidate.identityId === employee.identityId) === index;
    });

    return deduped.map(
      employee =>
        ({
          id: employee.identityId,
          employeeId: employee.employeeId,
          name: displayName(employee),
          contractId: employee.contract?.contractTypeId || undefined,
          contract: employee.contract?.contractTypeName || '',
          assignable: true,
          minorIssues: [],
          majorIssues: [],
          details: employee as any
        }) satisfies EmployeeForShiftItem
    );
  }, [allEmployees, missingEmployeesData?.employeesByIds]);
};

export const useTemplateEmployeesForShift = (shift: WorkingShift) => {
  const employees = useTemplateEmployees(shift.assignedEmployeeId);

  return useMemo(() => {
    return employees.map(employee => ({
      ...employee,
      name: employee.name || '-'
    }));
  }, [employees]);
};
